(function() {
  var DialogController, TraitPackage,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass("core::Angular/DialogController");

  TraitPackage = App.loadClass("portal::Angular/Ratings/Models/TraitPackage");

  exports.TraitPackageDialogController = (function(superClass) {
    extend(TraitPackageDialogController, superClass);

    function TraitPackageDialogController(scope, transitions, repo, modalInstance, lineups_id, trait_package, trait_suppliers) {
      var tp;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modalInstance = modalInstance;
      this.save = bind(this.save, this);
      TraitPackageDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      tp = new TraitPackage();
      if (trait_package != null) {
        this.scope.trait_package = $.extend(tp, trait_package);
        this.scope.title = 'Edit Trait Package';
      } else {
        this.scope.trait_package = tp;
        this.scope.title = 'Add Trait Package';
        this.scope.$watch('trait_package.name', (function(_this) {
          return function(val) {
            var comp_val;
            comp_val = val != null ? val.trim().toLowerCase() : void 0;
            switch (comp_val) {
              case 'conv':
              case 'conventional':
                return _this.scope.trait_package.suffix = '';
              default:
                return _this.scope.trait_package.suffix = val;
            }
          };
        })(this));
      }
      this.scope.trait_suppliers = trait_suppliers;
      this.scope.show_overflow = true;
      this.scope.absolute_errors = false;
      this.lineups_id = lineups_id;
    }

    TraitPackageDialogController.prototype.save = function() {
      var promise;
      promise = this.repo.saveTraitPackage(this.lineups_id, this.scope.trait_package).then((function(_this) {
        return function(response) {
          var ref;
          if ((ref = response.status) != null ? ref.type : void 0) {
            return _this.closeWithAlert(response.status, response.data);
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.closeWithAlert({
            type: 'error',
            msg: 'Failed to save trait package'
          });
        };
      })(this));
      return promise;
    };

    return TraitPackageDialogController;

  })(DialogController);

}).call(this);
